export default {
	zhuye: '主页',
	qingshururiqi: '请输入日期!',
	jipiao: '机票',
	jiudian: '酒店',
	tongguo: '通过',
	shengdanshibailianxikefu: '生单失败,请联系客服',
	zhongzhuanzai: '中转在',
	zhongzhuanshijian: '中转时间',
	kenengxuyaolvxingzhengjian: '可能需要旅行证件/签证。',
	xinglitongguo: '行李通过',
	lvyoutaopiao: '旅游套票',
	dumiyue: '渡蜜月',
	remenyouhui: '热门优惠',
	chakanquanbu: '查看全部',
	tebietaopiao: '特别套票',
	lvyouxinxi: '旅游信息',
	gouwuzhongxin: '购物中心',
	hangban: '航班',
	chengkeziliao: '乘客资料',
	fuyingchanpin: '辅营产品',
	queren: '确认',
	fukuan: '付款',
	chenggong: '成功',
	xuanzehangban: '选择航班',
	piaojiaguize: '票价规则及备注',
	piaojiaguizes: '票价规则',
	feiwang: '飞往',
	fanhui: '返回',
	xiayibu: '下一步',
	gengduoxijie: '更多',
	yincangxijie: '隐藏',
	gengduo: '更多',
	gengshao: '更少',
	genggaihangban: '更改航班',
	jishangfuwu: '机上服务',
	boyinqi: '波音777-300ER',
	yihaohangzhan: '1号航站楼',
	changlvkehao: '常旅客号',
	suoyoufeixingshijian: '所有飞行时间以24小时系统显示。',
	xinguanfeiyan:
		'关于新冠肺炎在不同国家的最新发展，我们建议过境旅客在购买机票之前，先查看过境机场的最新机场政策以及最终目的地的入境限制。',
	zhongyingbuyizhi: '如果目的地和航空公司名称的英文版和中文版之间有任何不一致之处，以英文版为准。',
	mingzitishi: `请以英文输入您的正式首个名字（以护照记录为准）<br >例如：如您的全名为：                   <br>
    「Kwok Fu Hsing」，请输入「Fu Hsing」。Cheung Pak Chi Cecilia」，请输入「Pak Chi Cecilia」.                 <br>
    请勿输入中文字。`,
	xingshitishi: '请以英文输入您的正式姓氏（以护照记录为准）：<br>例如：如您的全名为：<br>「Kwok Fu Hsing」，请输入「Kwok」。<br>「Cheung Pak Chi Cecilia」，请输入「Cheung」。<br>请勿输入中文字。',
	huzhaohaomatishi: '此航空公司需要您提供护照号码。',
	yudingchenggong: '预订成功！',
	yudingshibai: '预定失败',
	yudingcankao: '预订参考：',
	nindeyudingyiqueren: '您的预订已经确认。确认电子邮件已发送至',
	nindeyudingyishibai: '你的预定已经失败，请重新下单',
	ninyekyguanliwodeyuding: '您也可以在“我的预订”中管理您的航班预订。',
	piaojia: '票价',
	gongxianghangsi: '共享航司',
	caozuotongguo: '执飞航司',
	fanhuitishixinxi: '如果您离开此页面，订单将不再保留，价格可能会更改。你确定要离开吗？',
	wuxingli: '无免费行李额',
	xingqi1: '周一',
	xingqi2: '周二',
	xingqi3: '周三',
	xingqi4: '周四',
	xingqi5: '周五',
	xingqi6: '周六',
	xingqi0: '周日',
	fareRules: {
		tuipiao: "退票",
		gaiqi: "改期",
		tuigaishuoming: "退改说明",
		qifeiqian: "起飞前",
		qifeihou: "起飞后",
		buketuipiao: "不可退票",
		buketuishui: "不可退税",
		bukegaiqi: "不可改期",
		mianfeituipiao: "免费退票",
		mianfeituishui: "免费退税",
		mianfeigaiqi: "免费改期",
		tuipiaofei: "退票费",
		tuishuifei: "退税费",
		gaiqifei: "改期费",
		quanchengweishiyong: "全程未使用",
		quchengyishiyong: "去程已使用，退回程",
		chufahangban: "出发航班",
		huichenghangban: "回程航班"
	}
};
